import React from 'react';
import PropTypes from 'prop-types';
import { Grid, /* TextField, */ Button,  } from '@material-ui/core';
import { reduxForm, Field } from 'redux-form';
import { buttonsApp } from '../../styles/GeneralStyles';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import FileInputRedux from './FileInputRedux';

const UploadFiles = props => {
    const {handleSubmit, valid, getBack, filesRequest} = props
    const classes = buttonsApp()
    console.log(props)

    return (
        <div>
            <form  onSubmit={ handleSubmit }>
                <Grid container spacing={3} justifyContent="center" alignItems="center">
                    {
                        filesRequest.map(fr => {
                            return  <Grid item xs={12} md={12} lg={12} xl={12}>
                                        <Field
                                            name={fr.name}
                                            label = {fr.label}
                                            type="file"
                                            component={ FileInputRedux }
                                        />
                                    </Grid>
                        })
                    }
                    
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        
                    </Grid>
                    <Grid item xs={12} md={6} lg={6} xl={6}>
                        <Button variant="contained" type="submit"
                            fullWidth
                            style={{height: '100%'}}
                            className={classes.buttonStandard}
                            disabled={!valid }
                            >
                            Continuar
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6} xl={6}>
                        <Button variant="contained" onClick={getBack}
                            fullWidth
                            style={{height: '100%'}}
                            className={classes.buttonStandard}
                            //  disabled={valid }
                            >
                            Atras
                        </Button>
                    </Grid>
                    
                </Grid>
            </form>
        </div>
    );
};

UploadFiles.propTypes = {
    getBack: PropTypes.func.isRequired
};

const UploadFilesReduxForm = reduxForm(
    {
        form: 'UploadFiles',
        // validate,
        destroyOnUnmount: false

    }
)(UploadFiles)

export default setPropsAsInitial(UploadFilesReduxForm);

// export default UploadFiles;